export const SANDBOX_APPLICATIONS_PROGRESS = "SANDBOX_APPLICATIONS_PROGRESS";
export const SANDBOX_APPLICATIONS_UPDATE = "SANDBOX_APPLICATIONS_UPDATE";
export const SANDBOX_APPLICATIONS_CLEAR = "SANDBOX_APPLICATIONS_CLEAR";
